module.exports = __webpack_public_path__ + "media/images/playlist-e3c361dc9530f51c9de571914e267d71.png";